import { defineComponent as _defineComponent } from 'vue'
import { createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createElementVNode as _createElementVNode, createBlock as _createBlock, withCtx as _withCtx, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-e0d939ee"),n=n(),_popScopeId(),n)
const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 1,
  class: "help-text"
}
const _hoisted_3 = {
  key: 2,
  class: "help-text"
}
const _hoisted_4 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("p", null, " Select a parent user: ", -1))

import { computed, ref } from 'vue'
import { useUserSupervisorStore } from '@/gp/UserSupervisorStore'
import { UserSupervisor } from '@/gp/GroupAdminModel'
import { useTokenManager } from '@/auth/TokenManager'
import { LoadMode } from '@/util/AsyncData'
import Modal from '@/util/Modal.vue'
import UserSelector from './UserSelector.vue'
import UserItem from './UserItem.vue'


export default /*#__PURE__*/_defineComponent({
  __name: 'UserSupervisorAddModal',
  setup(__props, { expose: __expose }) {

const supervisorIdRef = ref<string>()
const modalRef = ref<InstanceType<typeof Modal>>()

const userSupervisorStore = useUserSupervisorStore()
const tokenManager = useTokenManager()

__expose({
  open
})

const forUserIdRef = ref<string>()
const enableAddRef = computed(() => !!supervisorIdRef.value)
const supervisorsRef = computed(() => userSupervisorStore.getForSupervisedUser(forUserIdRef.value, LoadMode.EnsureLoaded))
const isFirstSupervisorRef = computed(() => supervisorsRef.value.length == 0)
const okStyleRef = computed(() => isFirstSupervisorRef.value ? "danger" : undefined)

function open(forUserId: string) {
  forUserIdRef.value = forUserId
  modalRef.value?.open()
}

function onSupervisorSelected(userId: string) {
  supervisorIdRef.value = userId
}

function clearSelected() {
  supervisorIdRef.value = undefined
}

async function addSupervisor() {
  const isFirst = isFirstSupervisorRef.value

  const sup = new UserSupervisor()
  sup.supervisorId = supervisorIdRef.value
  sup.forUserId = forUserIdRef.value
  await userSupervisorStore.addAsync(sup)

  if (isFirst) {
    await tokenManager.refreshAsync()
    window.location.reload()
  }
  else {
    modalRef.value?.close()
  }
}


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(Modal, {
    ref_key: "modalRef",
    ref: modalRef,
    "ok-style": okStyleRef.value,
    "ok-disabled": !enableAddRef.value,
    onOk: addSupervisor
  }, {
    title: _withCtx(() => [
      _createTextVNode(" Add parent account ")
    ]),
    okText: _withCtx(() => [
      _createTextVNode("Add parent")
    ]),
    default: _withCtx(() => [
      (isFirstSupervisorRef.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_1, " To make this a child account, select a parent to manage it. "))
        : _createCommentVNode("", true),
      (isFirstSupervisorRef.value)
        ? (_openBlock(), _createElementBlock("p", _hoisted_2, " When you add a parent account, the child account will no longer be able to add to or change their personal information, and some features of the site will be disabled. The parent account will have full control of the child account. "))
        : (_openBlock(), _createElementBlock("p", _hoisted_3, " Each parent account will have full control over the child account. ")),
      _hoisted_4,
      _createElementVNode("div", null, [
        (supervisorIdRef.value)
          ? (_openBlock(), _createBlock(UserItem, {
              key: 0,
              "user-id": supervisorIdRef.value,
              "select-mode": "",
              onClick: clearSelected
            }, null, 8, ["user-id"]))
          : (_openBlock(), _createBlock(UserSelector, {
              key: 1,
              onUserSelected: onSupervisorSelected
            }))
      ])
    ]),
    _: 1
  }, 8, ["ok-style", "ok-disabled"]))
}
}

})